import "./About.css";
import { useEffect, useRef, useState } from "react";

import Lines from "../../assets/lines.png";

const About = () => {

    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {

        const observer = new IntersectionObserver(
            ([entry]) => {

                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }

            },
            {
                threshold: 0.2,
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();

    }, []);

    return (

        <section
            ref={sectionRef}
            className={`about ${visible ? "show" : ""}`}
        >

            <div className="about__container">

                <div className="about__title">
                    <h2>
                        Los datos transforman el conocimiento.
                        <br />
                    </h2>
                </div>

                <div>
                    <img src={Lines} alt="" className="lines-position" />
                </div>

                <div className="about__card">

                    <h3>
                        ¿Quiénes Somos?
                    </h3>

                    <p>
                        Vemasmas es una empresa mexicana de tecnología e innovación,
                        reconocida por su liderazgo en el desarrollo de soluciones
                        digitales, análisis de datos y tecnología basada en UAS.
                    </p>

                    <button>
                        Ver Más
                        <span>→</span>
                    </button>

                </div>

            </div>

        </section>

    );
};

export default About;
